import React, { useEffect, useState, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ShubhamImage from '../../assest/images/reportlogo1.png';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import { ToastContainer, toast } from 'react-toastify';
import CustomSingleValue from '../common/CustomSingleValue';
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';

const Inventory = () => {
    const [inventoryData, setInventoryData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [pdfdata, setpdfdata] = useState();
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const tableRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // you can adjust this number
     const [isLoading,setIsLoadig] = useState(false)

    // Get current records
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    useEffect(() => {
        console.log()
        fetch(`${config.API_URL}/IR/invdata/${selectedScpId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log(data);
                setpdfdata(data) // Log the data to the console
                setInventoryData(data);
                setFilteredData(data);
                const optionsData = [
                    { value: "ALL", label: "--Select--" },
                    ...data.map(item => ({
                        value: item.PL_ProductCode,
                        label: item.PL_ProductName
                    }))
                ];
                setOptions(optionsData);
            })
            .catch(error => console.error(error));
    }, [selectedScpId]);

    const handleSelectChange = selectedOption => {
        setSelectedOption(selectedOption);

        if (selectedOption && selectedOption.value !== "ALL") {
            const filtered = inventoryData.filter(item =>
                item.PL_ProductCode === selectedOption.value ||
                item.PL_ProductName === selectedOption.label
            );
            setFilteredData(filtered);
            setpdfdata(filtered);
        } else {
            setFilteredData(inventoryData);
            setpdfdata(inventoryData);
        }
    };

    const generatePDF = async (orderNumber) => {
        console.log(orderNumber);
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });
        const textColor = [0, 0, 0]; // Black (RGB)
        const headerTextColor = [255, 255, 255]; // White (RGB)
        const headerColor = [135, 206, 250]; // Light Blue (RGB)
        const rowColor = [255, 255, 255]; // White (RGB)
        const styles = {
            title: {
                fontSize: 24,
                color: textColor,
                fontStyle: 'bold',
                margin: { top: 20 },
                align: 'center',
            },
            detailsTable: {
                fontSize: 12,
                color: textColor,
                margin: { top: 10 },
                fillColor: rowColor,
            },
            tableHeader: {
                fontSize: 12,
                color: headerTextColor,
                fontStyle: 'bold',
                fillColor: headerColor,
            },
            tableRow: {
                fontSize: 10,
                color: textColor,
                fillColor: rowColor,
            },
        };
        //const imgData = ShubhamImage; // Assuming ShubhamImage is your image data
        const logoRes = await fetch(`${config.API_URL}/logo-base64/${UM_CompanyGrpID}`);
        const logoJson = await logoRes.json();
        const imgData = logoJson.base64 || ShubhamImage;
        doc.addImage(imgData, 'PNG', 10, 10, 40, 20);
        // const printedBy = `Printed By: ${UM_UserCode}`;
        // const printedOn = `Printed On: ${new Date().toLocaleString()}`;
        const date = new Date();
        const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")
            }/${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")
            }:${String(date.getMinutes()).padStart(2, "0")
            }:${String(date.getSeconds()).padStart(2, "0")}`;

        // const printedBy = `Printed By : ${UM_UserCode}`;
        // const printedOn = `Printed On : ${formattedDate}`;
        const startX = doc.internal.pageSize.getWidth() - 50;
        const startY = 20;
        const baseX = startX;
        const y1 = startY + 5;
        const y2 = startY;

        const colonOffset = 14.5;  // distance from label to colon
        const valueOffset = 16.5;  // distance from label to value (a few px after colon)

        doc.setFontSize(8);

        // 📝 Printed On
        doc.text("Printed On", baseX, y2, { align: "left" });
        doc.text(":", baseX + colonOffset, y2);
        doc.text(formattedDate, baseX + valueOffset, y2);

        // 📝 Printed By
        doc.text("Printed By", baseX, y1, { align: "left" });
        doc.text(":", baseX + colonOffset, y1);
        doc.text(UM_UserCode, baseX + valueOffset, y1);

        const shipmentInfo = [
            [{ content: 'Inventory Report', colSpan: 2, styles: { halign: 'center', fontSize: 20, fillColor: [41, 128, 185], textColor: [255, 255, 255] } }]
        ];
        const productdetails = pdfdata.map((item, index) => [
            index + 1,                          // Sr. No.
            // item.SCPM_Name,                     // SCP Name
            item.PL_ProductName,                // Product Name
            item.PL_ProductCode,                // Product Code
            item.inv_availableqty,              // Avl. Quantity
            item.inv_blockqty                   // Block Quantity
        ]);
        console.log(productdetails);
        const headers = ["Sr. No.", "Product Name", "Product Code", " Available Quantity", " Block Quantity"];
        doc.autoTable({
            head: [],
            body: shipmentInfo,
            startY: startY + 15,
            theme: 'grid',
            styles: {
                cellPadding: 2,
                valign: 'middle',
                halign: 'left',
            },
        });
        doc.autoTable({
            head: [headers],
            body: productdetails,
            startY: doc.autoTable.previous.finalY,
            theme: 'grid',
            headStyles: {
                ...styles.detailsTable,
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
                lineWidth: 0.25,
                cellPadding: 2,
                valign: 'middle',
                halign: 'left',
                minCellHeight: 8,
                // Replace rowHeight with minCellHeight
                border: {
                    top: { style: 'solid', width: 0.25, color: [0, 0, 0] },
                },
            },
            styles: {
                cellPadding: 2,
                valign: 'middle',
                halign: 'left',
                textColor: [0, 0, 0],
                fontSize: 10,
                // fontStyle: 'bold',
            },
        });
        const columnWidth1 = (doc.internal.pageSize.width - 30) / 4

        // Signature section styling
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, "normal");

        const tableContent = [
            ['', '              Name', '          Signature', '              Date'],

            ['Checked By :', '_____________________', '_____________________', '_____________________'],
            ['Verified By   :', '_____________________', '_____________________', '_____________________']
        ];
        doc.autoTable({
            startY: doc.autoTable.previous.finalY + 10,
            body: tableContent,
            theme: 'plain',
            columnStyles: {
                0: { cellWidth: columnWidth1 },
                1: { cellWidth: columnWidth1 },
                2: { cellWidth: columnWidth1 }

            },
            styles: { fontSize: 10 },
            headStyles: { fontWeight: 'normal' },
            margin: { top: 35 }, // Reserve space for header (25 for text + padding)
            didDrawPage: function (data) {

                doc.setFontSize(8);

            }
        });


        // Add page numbering
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.getHeight();
            const pageWidth = pageSize.getWidth();
            doc.setFontSize(8);
            doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 10, { align: 'right' });
        }
        addFooter(doc);
        let fileName = "All_Product_Inventory.pdf";
        if (selectedOption) {
            // Replace spaces with underscores for cleaner filenames
            const safeProductName = selectedOption.label.replace(/\s+/g, "_");
            fileName = `${safeProductName}_Inventory.pdf`;
        }

        doc.save(fileName);
    }

    const handleDownloadPdf = async () => {
        try {
            setIsLoadig(true)
            const response = await fetch(`${config.API_URL}/Report/inventory-pdf`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    selectedScpId,
                    selectedOption: selectedOption || options.find(opt => opt.value === "ALL"),
                    UM_CompanyID,
                    UM_UserCode
                }),
            });

            // ❌ handle 404 / 500 properly
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // ✅ get PDF blob
            const blob = await response.blob();

            // ✅ download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Inventory_Report.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success('PDF downloaded successfully.',{onClose:()=> setIsLoadig(false)});


        } catch (error) {
            console.error('PDF download error:', error);
            toast.error('Failed to download PDF',{onClose:()=> setIsLoadig(false)});
        }
    };

    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);

    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);

    };
    const addFooter = (doc) => {
        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            // Go to page i
            doc.setPage(i);

            // Set text alignment to left
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0); // Black color
            doc.text(
                "Developed by : Shubham Automation Pvt. Ltd.",
                10,
                doc.internal.pageSize.getHeight() - 10
            ); // at left side of the page

            // Add page number to the right side of the page
            //   doc.text(
            //     `Page ${i} of ${totalPages}`,
            //     doc.internal.pageSize.getWidth() - 20,
            //     doc.internal.pageSize.getHeight() - 10,
            //     { align: "right" }
            //   );
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [filteredData.length]);


    return (
        <>
            <ToastContainer
                style={{
                    marginTop: '73px',
                    fontSize: '14px',
                    width: '40%',
                }}
            />
            {isLoading && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height

                    zIndex: 9999 // Sit on top of the other elements
                }} />
            )}
            <div className="main_container">
                <div>
                    <h3 className="formHeading">Inventory Report</h3>
                </div>
                <div className='inventoryfilter-container'>
                    <div className='select-container_list' style={{maxWidth:'85%'}} >
                        <Select
                            className='inventory_select '
                            classNamePrefix="react-select"
                            options={options}
                            value={selectedOption || options.find(opt => opt.value === "ALL")}
                            onChange={handleSelectChange}
                            placeholder="--Select--"
                            maxMenuHeight={"140px"}
                            onMenuOpen={() => handleSelectOpen('Product')}
                            onMenuClose={handleSelectClose}
                            components={{ SingleValue: CustomSingleValue }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    cursor: 'pointer',
                                    borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                    boxShadow: state.isFocused ? 'none' : base.boxShadow,
                                    '&:hover': {
                                        borderColor: '#cfcfcf',
                                    },
                                }),
                                menu: (base) => ({
                                    ...base,
                                    marginTop: -1,
                                }),
                            }}
                        />

                        <div className='icon-container'>
                            {isSelectOpen === 'Product' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                        </div>
                    </div>
                    <button
                        onClick={() => {
                            if (currentItems.length === 0) return;
                            handleDownloadPdf();
                        }}
                        className="report_btn"
                    >
                        DOWNLOAD PDF
                    </button>

                </div>
                <div className="ptable-wrapper" ref={tableRef}>
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                {/* <th>SCP Name</th> */}
                                <th>Product Name</th>
                                <th>Product Code</th>
                                <th>Available Quantity</th>
                                <th>Blocked Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{indexOfFirstItem + index + 1}</td>
                                        <td>{item.PL_ProductName}</td>
                                        <td>{item.PL_ProductCode}</td>
                                        <td>{item.inv_availableqty}</td>
                                        <td>{item.inv_blockqty}</td>
                                    </tr>
                                ))

                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No Records Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>



                </div>

                <ul className="pagination">
                    {/* First Page */}
                    <li className={currentPage === 1 || filteredData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>

                    {/* Previous Page */}
                    <li className={currentPage === 1 || filteredData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>

                    {/* Page Numbers */}
                    {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}

                    {/* Next Page */}
                    <li className={currentPage === Math.ceil(filteredData.length / itemsPerPage) || filteredData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>

                    {/* Last Page */}
                    <li className={currentPage === Math.ceil(filteredData.length / itemsPerPage) || filteredData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>


            </div> {/**main container */}
        </>
    )
}
export default Inventory;